import {register} from '../vendor/theme-scripts/theme-sections';
import $ from 'jquery';

const imageTextSlider = {
  onLoad() {
    this.imageTextSlider = new ImageTextSlider(this);
  },
};

class ImageTextSlider {
  constructor(section) {
    this.container = section.container;
    this.init();
  }
  init() {
    const $slick = $(this.container).find(`[data-slick-slider]`);
    $(this.container).find(`.card__nav__btn`).click(function(evt){
      const index = parseInt( $(this).attr(`data-index`) );
      $slick.slick('goTo', index);
    })
  }
}

register('image-text-slider', [imageTextSlider]);
